import React, { useEffect } from 'react';

const ensureToastStyles = () => {
  if (typeof document === 'undefined') {
    return;
  }
  if (document.getElementById('react-toast-styles')) {
    return;
  }
  const style = document.createElement('style');
  style.id = 'react-toast-styles';
  style.textContent = `
    .toast-stack {
      position: fixed;
      top: 20px;
      right: 20px;
      z-index: 10000;
      display: flex;
      flex-direction: column;
      gap: 12px;
      pointer-events: none;
    }
    .toast-notification {
      background: #ffffff;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      border: 1px solid #e5e7eb;
      padding: 12px 16px;
      min-width: 280px;
      animation: slideInRight 0.3s ease-out;
      pointer-events: auto;
    }
    .toast-warning {
      border-left: 4px solid #f59e0b;
    }
    .toast-error {
      border-left: 4px solid #ef4444;
    }
    .toast-info {
      border-left: 4px solid #3b82f6;
    }
    .toast-content {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 14px;
      color: #374151;
    }
    .toast-dismiss {
      background: transparent;
      border: none;
      cursor: pointer;
      padding: 0;
      margin-left: 8px;
      color: #6b7280;
    }
    @keyframes slideInRight {
      from {
        transform: translateX(100%);
        opacity: 0;
      }
      to {
        transform: translateX(0);
        opacity: 1;
      }
    }
  `;
  document.head.appendChild(style);
};

const iconForType = (type) => {
  if (type === 'warning') return 'alert-triangle';
  if (type === 'error') return 'x-circle';
  return 'info';
};

const ToastContainer = ({ toasts, onDismiss }) => {
  useEffect(() => {
    ensureToastStyles();
  }, []);

  if (!toasts?.length) {
    return null;
  }

  return (
    <div className="toast-stack">
      {toasts.map((toast) => (
        <div key={toast.id} className={`toast-notification toast-${toast.type || 'info'}`}>
          <div className="toast-content">
            <i data-lucide={iconForType(toast.type)} />
            <span>{toast.message}</span>
            <button
              type="button"
              className="toast-dismiss"
              onClick={() => onDismiss?.(toast.id)}
            >
              <i data-lucide="x" />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;

